import React from 'react';

import ConfirmationExitBox from '../../ConfirmationExitBox';
import config from '../../../../config/config';
import dollarSignMonitor from '../../../../assets/images/dollar-sign-monitor.svg';
import recurringCalendar from '../../../../assets/images/recurring-calendar.svg';
import sellDashboard from '../../../../assets/images/sell-dashboard.svg';
import planningDetails from '../../../../assets/images/planning-details.svg';

export const AppBuyWhatsNext = ({ rasFundsOnly }) => (
  <div className="buy-whats-next-exit-container">
    <div>
      <div className="buy-whats-next-exit-heading">What's next?</div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-setup-recurring'}
            className={'e2e-confirm-setup-recurring'}
            heading={'Submit Another Trade'}
            subHeading={
              <div>
                Transact using your{' '}
                <span className="text-nowrap">T. Rowe Price accounts.</span>
              </div>
            }
            image={dollarSignMonitor}
            exitLocation={`${config.url}/usis/transactions/landing`}
          />
        </div>
        {!rasFundsOnly && (
          <div className="col-sm-12 col-md-4 col-lg-4">
            <ConfirmationExitBox
              id={'confirm-expand-portfolio'}
              className={'e2e-confirm-expand-portfolio'}
              heading={'Set Up Recurring Investments'}
              subHeading={`Scheduling automatic deposits makes adding to your portfolio simple.`}
              image={recurringCalendar}
              exitLocation={`${config.url}/usis/transactions/automatic`}
            />
          </div>
        )}
        {rasFundsOnly && (
          <div className="col-sm-12 col-md-4 col-lg-4">
            <ConfirmationExitBox
              id={'confirm-expand-portfolio'}
              className={'e2e-confirm-expand-portfolio'}
              heading={'View Planning Details'}
              subHeading={`Take a look at your overall planning details and checkout our simulation tools as well.`}
              image={planningDetails}
              exitLocation={`${config.url}/usis/advice/planning-details`}
            />
          </div>
        )}
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-view-dashboard'}
            className={'e2e-confirm-view-dashboard'}
            heading={'View Your Dashboard'}
            subHeading={`Review your portfolio and track how your investments are performing.`}
            image={sellDashboard}
            exitLocation={`${config.url}/usis/my-accounts/`}
          />
        </div>
      </div>
    </div>
  </div>
);

export default AppBuyWhatsNext;
